module.exports = __webpack_public_path__ + "img/q6-opt-a.db863ae3.png";